var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice",class:{
    'notice--warning': _vm.isWarning,
    'notice--error': _vm.isError,
    'notice--success': _vm.isSuccess,
    'notice--info': _vm.isInfo,
  }},[(_vm.isArray)?_c('div',_vm._l((_vm.message),function(item){return _c('div',{key:item},[_vm._v(" "+_vm._s(item)+" ")])}),0):_vm._e(),(!_vm.isArray)?_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }